module.exports = __webpack_public_path__ + "img/pro_feature_calendar_sync.c2546bd.png";